import React from 'react';
import PropTypes from 'prop-types';

import { ContextProvider as ResourceNotesContextProvider } from 'components/ResourceNotes/Context';
import NewNote from 'components/ResourceNotes/Views/New/Index';
import NotesList from 'components/ResourceNotes/Views/List/Index';

import Brief from './Briefs/Index';
import Reports from './Reports/Index';

export default function Index({
  enterpriseId,
}) {
  return (
    <>
      <Brief enterpriseId={enterpriseId} />
      <Reports enterpriseId={enterpriseId} />
      <ResourceNotesContextProvider resourceType="Enterprise" resourceId={enterpriseId}>
        <div className="ibox-content mt20">
          <h2 className="block-title">
            Notes
          </h2>

          <NewNote />
          <NotesList />
        </div>
      </ResourceNotesContextProvider>
    </>
  );
}

Index.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
  slackRedirectUrl: PropTypes.string.isRequired,
  slackEnabled: PropTypes.bool.isRequired,
  slackEnabledAt: PropTypes.string,
};

Index.defaultProps = {
  slackEnabledAt: '',
};
